import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { consumeAuthRedirect } from "@/core/lib/auth-redirect";
import { setAuthMethod, setTokenExpiry } from "@/core/lib/auth-session";
import type { TwoFaRecoveryCodesResponse } from "@/openapi/types.gen";

export function useTwoFaCompletion() {
  const navigate = useNavigate();
  const [recoveryCodes, setRecoveryCodes] = useState<string[] | null>(null);

  function finish(ignoreBlocker = false) {
    const redirectTo = consumeAuthRedirect();
    return navigate({
      to: redirectTo ?? "/",
      replace: true,
      ...(ignoreBlocker ? { ignoreBlocker: true } : {}),
    });
  }

  function complete(data: TwoFaRecoveryCodesResponse | boolean | null) {
    setAuthMethod("jwt");
    if (data && typeof data === "object") {
      if ("expires_in" in data && typeof data.expires_in === "number") {
        setTokenExpiry(data.expires_in);
      }
      if (data.recovery_codes !== null && data.recovery_codes !== undefined) {
        setRecoveryCodes(data.recovery_codes);
        return;
      }
    }
    return finish();
  }

  async function continueAfterSaving() {
    await finish(true);
    setRecoveryCodes(null);
  }

  return { recoveryCodes, complete, continueAfterSaving };
}
